import { useEffect, useRef, useState } from "react";

/**
 * 限速冷却（#897）：登录 / 注册 / 找回密码遇到 429 后，把提交按钮禁用 Retry-After 那么多秒。
 * 返回 [是否冷却中, 开始冷却(秒)]。
 */
export const useCooldown = (): [boolean, (seconds: number) => void] => {
    const [cooling, setCooling] = useState(false);
    const timer = useRef<ReturnType<typeof setTimeout> | null>(null);

    useEffect(() => () => {
        if (timer.current) {
            clearTimeout(timer.current);
        }
    }, []);

    const start = (seconds: number) => {
        if (timer.current) {
            clearTimeout(timer.current);
        }
        setCooling(true);
        timer.current = setTimeout(() => {
            timer.current = null;
            setCooling(false);
        }, seconds * 1000);
    };

    return [cooling, start];
};
